const profile = {
  name: "Karan Sreedhar",
  title: "MS CS Graduate · UIC · May 2026",
  subtitle: "Computer Science | UIC | Chicago, IL",
  photo: "/profile_photo.png",
  tagline: "",
  bio: [
    "MS Computer Science graduate from UIC (May 2026) with experience in backend engineering, ML systems, and cloud-native infrastructure.",
    "Built and deployed production systems spanning distributed storage, RAG pipelines on AWS, and full-stack web applications.",
    "Proficient in Python, Scala, and TypeScript, with practical experience in Spark, Flink, Docker, and Kubernetes. Currently pursuing CKAD.",
    "Seeking backend, ML engineering, or DevOps roles."
  ],
  links: {
    github: "https://github.com/karan1505",
    linkedin: "https://www.linkedin.com/in/karansreedhar1505/",
    email: "karansreedhar15@gmail.com",
    cv: "/CV - Final.pdf"
  },
  status: "Seeking Backend · ML Engineering · DevOps · May 2026"
};

export default profile;
